export default "__VITE_ASSET__7ccb3d09__"